import { createContext } from 'react';

const OrdersContext = createContext();
export default OrdersContext;
